import firebase from 'firebase/app';
const FieldValue = firebase.firestore.FieldValue;

export function firestoreArrayUnion(
  ...elements: unknown[]
): firebase.firestore.FieldValue {
  return FieldValue.arrayUnion(...elements);
}
